import React from "react";

/**
 * Sticky bottom action bar for multi-step wizards.
 * Stays inside the document flow on desktop, becomes fixed-to-bottom on mobile.
 */
export default function WizardFooter({ children }) {
  return (
    <>
      {/* Spacer so content isn't hidden behind the fixed footer + bottom nav on mobile.
          Footer sits at bottom-20 (80px); BottomNav ~64px; safe-area can add ~34px;
          plus breathing room — 160px reserves enough that the LAST field is fully scrollable. */}
      <div className="h-40 md:h-0" aria-hidden />
      <div
        className="fixed bottom-20 qd-pb-safe-wizard left-0 right-0 z-30 px-4 pb-3 md:static md:px-0 md:pb-0 md:mt-2 md:bottom-auto"
        style={{ pointerEvents: "none" }}
      >
        <div
          className="max-w-2xl mx-auto qd-glass md:bg-transparent md:backdrop-blur-0 md:border-0 border border-white/10 p-3 md:p-0"
          style={{ pointerEvents: "auto" }}
        >
          {children}
        </div>
      </div>
    </>
  );
}
